﻿$.fn.dxCtrlPageSaisieCbExterneSumUp = function custom_dxCtrlPageSaisieCbExterneSumUp(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlpagesaisiecbexternesumup");
        this.instance = new cdxCtrlPageSaisieCbExterneSumUp(this, option);
    }
    return this;
}

window.cdxCtrlPageSaisieCbExterneSumUp = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var $DivContainer = null
    function mConstruit() {
        container.empty()
        container.css({
            "display": "flex",
            //"align-items": "center",
            "justify-content": "center",
            "padding-top": "30px"
        })

        $DivContainer = $("<div style='text-align:center;'/>").appendTo(container)

        var nomTable = option.bddCtrl.table.mGetItem(option.idTable).nom
        var objForCb = option.bddCtrl.getObjet(nomTable, option.id)

        if (typeof objForCb.data == 'undefined') {
            //le document n'existe plus
            switch (nomTable) {
                case "reservation_arrhes":
                    mDisplayResult("Ces arrhes ne sont plus disponible", option.idTable, option.id, 0)
                    break;
                default:
                    mDisplayResult("Le document que vous voulez régler n'existe pas", option.idTable, option.id, 0)
                    break;
            }
            jaugeDemarrage.mHide()
        } else {
            switch (nomTable) {
                case "doc_cpt":
                    mTraiteCbDocCpt()
                    break;
                default:
                    mTraiteGeneral()
                    break;
            }
        }

    }

    function mTraiteGeneral() {
        var nomTable = option.bddCtrl.table.mGetItem(option.idTable).nom
        var obj = option.bddCtrl.getObjet(nomTable, option.id)
        if (obj.data.date_reglement) {
            mDisplayResult("Ces arrhes ont déjà été réglé", option.idTable, option.id, 0)
        } else {
            $("<div/>").appendTo("body").dxCtrlPageSaisieCbSumUp({
                bddCtrl: option.bddCtrl,
                amount100: (obj.data.mt * 100),
                id_societe: option.bddCtrl.mGetArray("societe")[0].id_societe,
                id_table: option.idTable,
                id: option.id,
                onValidePaiement: function (amount100, paiementIntent) {
                    jaugeDemarrage.mShow()
                    window.setTimeout(function () {
                        jaugeDemarrage.mShow()
                        window.setTimeout(function () { jaugeDemarrage.mShow() }, 200)
                    }, 0)
                    switch (nomTable) {
                        case "reservation_arrhes":
                            option.bddCtrl.mReloadItem(option.bddCtrl.getObjet(nomTable, option.id).data, function () {
                                var objResaArrhes = option.bddCtrl.getObjet(nomTable, option.id)
                                option.bddCtrl.mReloadItem(option.bddCtrl.getObjet("reservation", objResaArrhes.data.id_reservation).data, function () {
                                    var objResa = option.bddCtrl.getObjet("reservation", objResaArrhes.data.id_reservation)
                                    var adresseEmail = objResa.objetMetier.mGetAdresseEmailDestinataire()
                                    if (adresseEmail.length > 0) {
                                        option.bddCtrl.mAjaxCall({
                                            command: "sendemailmessageclient",
                                            adresse_email: adresseEmail,
                                            keyparasignature: "hebergement_modele_email_information_reservation_confirm_reglement_arrhes",
                                            html_complement_body: objResa.objetMetier.mGetElementRecapitulatif().prop("outerHTML")
                                        }, function (data) {
                                            mDisplayResult(
                                                "<br/><br/>Votre réservation est maintenant confirmée.<br/><br/>Un email de confirmation d'arrhes avec le récapitulatif de la réservation a été envoyé à <a>" + adresseEmail + "</a>",
                                                option.idTable,
                                                option.id,
                                                option.bddCtrl.mGetArray("societe")[0].id_societe,
                                                function (contentElement) {
                                                    //var $A = $("<a href='javascript:void(0)'>Télécharger votre facture</a>").appendTo(contentElement)
                                                    //$A.on("click", function (e) {
                                                    //    jaugeDemarrage.mShow()
                                                    //    docCptDetailFinal.mGetUrlPdfDocCpt(function (urlPdf) {
                                                    //        $("<div/>").dxCtrlPdfViewer({
                                                    //            urlPdf: urlPdf
                                                    //        })
                                                    //        jaugeDemarrage.mHide()
                                                    //    })
                                                    //})
                                                })
                                            jaugeDemarrage.mHide()
                                        })
                                    }
                                })
                            })
                            break;
                        default:
                            break;
                    }
                    //option.bddCtrl.mAjaxCall({
                    //    command: "validpaiementcbinternet",
                    //    id_table: option.idTable,
                    //    id: option.id,
                    //    amount100: amount100,
                    //    nom_base: option.nomBase,
                    //    paiement_intent: JSON.stringify(paiementIntent)
                    //}, function (data) {
                    //    switch (nomTable) {
                    //        case "reservation_arrhes":
                    //            option.bddCtrl.mReloadItem(option.bddCtrl.getObjet(nomTable, option.id).data, function () {
                    //                var objResaArrhes = option.bddCtrl.getObjet(nomTable, option.id)
                    //                option.bddCtrl.mReloadItem(option.bddCtrl.getObjet("reservation", objResaArrhes.data.id_reservation).data, function () {
                    //                    var objResa = option.bddCtrl.getObjet("reservation", objResaArrhes.data.id_reservation)
                    //                    var adresseEmail = objResa.objetMetier.mGetAdresseEmailDestinataire()
                    //                    if (adresseEmail.length > 0) {
                    //                        option.bddCtrl.mAjaxCall({
                    //                            command: "sendemailmessageclient",
                    //                            adresse_email: adresseEmail,
                    //                            keyparasignature: "hebergement_modele_email_information_reservation_confirm_reglement_arrhes",
                    //                            html_complement_body: objResa.objetMetier.mGetElementRecapitulatif().prop("outerHTML")
                    //                        }, function (data) {
                    //                            mDisplayResult(
                    //                                "<br/><br/>Votre réservation est maintenant confirmée.<br/><br/>Un email de confirmation d'arrhes avec le récapitulatif de la réservation a été envoyé à <a>" + adresseEmail + "</a>",
                    //                                option.idTable,
                    //                                option.id,
                    //                                option.bddCtrl.mGetArray("societe")[0].id_societe,
                    //                                function (contentElement) {
                    //                                    //var $A = $("<a href='javascript:void(0)'>Télécharger votre facture</a>").appendTo(contentElement)
                    //                                    //$A.on("click", function (e) {
                    //                                    //    jaugeDemarrage.mShow()
                    //                                    //    docCptDetailFinal.mGetUrlPdfDocCpt(function (urlPdf) {
                    //                                    //        $("<div/>").dxCtrlPdfViewer({
                    //                                    //            urlPdf: urlPdf
                    //                                    //        })
                    //                                    //        jaugeDemarrage.mHide()
                    //                                    //    })
                    //                                    //})
                    //                                })
                    //                            jaugeDemarrage.mHide()
                    //                        })
                    //                    }
                    //                })
                    //            })
                    //            break;
                    //        default:
                    //            break;
                    //    }
                    //})
                }
            }).dxCtrlPageSaisieCbSumUp("instance")
        }
    }

    function mTraiteCbDocCpt() {
        (new cDocCptDetail(option.bddCtrl)).mGetDocCptDetail(option.bddCtrl, option.id, function (docCptDetail) {
            if (docCptDetail.docCpt.reste_a_payer <= 0) {
                // le document comptable est soldé
                mDisplayResult(docCptDetail.mGetLeLa() + "" + docCptDetail.mGetNomDocument() + " est soldé" + ((docCptDetail.mGetLeLa() == "le") ? "" : "e"), option.idTable, option.id, docCptDetail.docCptSociete.id_societe)
                jaugeDemarrage.mHide()
            } else if (docCptDetail.docCpt.id_type_com == "5") {
                // on est sur un ticket
                mDisplayResult(docCptDetail.mGetLeLa() + "" + docCptDetail.mGetNomDocument() + " ne peut être réglé" + ((docCptDetail.mGetLeLa() == "le") ? "" : "e") + " par CB", option.idTable, option.id, docCptDetail.docCptSociete.id_societe)
                jaugeDemarrage.mHide()
            } else {
                jaugeDemarrage.mHide()
                var dxPageSaisieCbSumUp = $("<div/>").appendTo("body").dxCtrlPageSaisieCbSumUp({
                    showClose: false,
                    bddCtrl: docCptDetail.bddRef,
                    amount100: (docCptDetail.docCpt.reste_a_payer * 100).toFixed(0),
                    id_societe: docCptDetail.docCpt.id_societe,
                    id_table: docCptDetail.bddRef.getObjet("doc_cpt").mGetTable().id_table,
                    id: docCptDetail.docCpt.id_doc_cpt,
                    title: "Régler " + docCptDetail.mGetLeLa() + "" + docCptDetail.mGetNomDocument() + " " + docCptDetail.mGetNumDocument(),
                    onValidePaiement: function (amount100, paiementIntent) {
                        jaugeDemarrage.mShow()
                        switch (parseInt(docCptDetail.docCpt.id_type_com)) {
                            case 1: case 2: //devis //commande
                                //on génére la facture
                                docCptDetail.mReloadModeReglement(function () {
                                    docCptDetail.mTransformeNew("3", true, function (docCptDetailFacture) {
                                        mDisplayFinReglement("Vous avez soldé votre " + docCptDetail.mGetNomDocument() + "<br/>Un email vous a été envoyé.", docCptDetailFacture)
                                        mSendEmailFacture(docCptDetailFacture)
                                    })
                                })
                                break;
                            case 3: //facture
                                //on est sur une facture
                                mDisplayFinReglement("Votre règlement a été pris en compte<br/>sur votre facture<br/>Un email vous a été envoyé.", docCptDetail)
                                mSendEmailFacture(docCptDetail)
                                break;
                        }

                        function mDisplayFinReglement(txt, docCptDetailFinal) {
                            dxPageSaisieCbSumUp.mClose()
                            mDisplayResult(
                                txt + "<br/><br/>",
                                option.idTable,
                                option.id,
                                docCptDetail.docCptSociete.id_societe,
                                function (contentElement) {
                                    var $A = $("<a href='javascript:void(0)'>Télécharger votre facture</a>").appendTo(contentElement)
                                    $A.on("click", function (e) {
                                        docCptDetailFinal.mPrint("a4")
                                    })
                                })
                            jaugeDemarrage.mHide()

                        }
                        ////on enregistre le paiement CB sur le doccpt
                        //docCptDetail.bddRef.mAjaxCall({
                        //    command: "validpaiementcbinternet",
                        //    id_table: docCptDetail.bddRef.getObjet(docCptDetail.docCpt).mGetTable().id_table,
                        //    id: docCptDetail.docCpt.id_doc_cpt,
                        //    amount100: amount100,
                        //    paiement_intent: JSON.stringify(paiementIntent)
                        //}, function (data) {
                        //    switch (parseInt(docCptDetail.docCpt.id_type_com)) {
                        //        case 1: case 2: //devis //commande
                        //            //on génére la facture
                        //            docCptDetail.mReloadModeReglement(function () {
                        //                docCptDetail.mTransformeNew("3", true, function (docCptDetailFacture) {
                        //                    mDisplayFinReglement("Vous avez soldé votre " + docCptDetail.mGetNomDocument() + "<br/>Un email vous a été envoyé.", docCptDetailFacture)
                        //                    mSendEmailFacture(docCptDetailFacture)
                        //                })
                        //            })
                        //            break;
                        //        case 3: //facture
                        //            //on est sur une facture
                        //            mDisplayFinReglement("Votre règlement a été pris en compte<br/>sur votre facture<br/>Un email vous a été envoyé.", docCptDetail)
                        //            mSendEmailFacture(docCptDetail)
                        //            break;
                        //    }

                        //    function mDisplayFinReglement(txt, docCptDetailFinal) {
                        //        dxPageSaisieCbSumUp.mClose()
                        //        mDisplayResult(
                        //            txt + "<br/><br/>",
                        //            option.idTable,
                        //            option.id,
                        //            docCptDetail.docCptSociete.id_societe,
                        //            function (contentElement) {
                        //                var $A = $("<a href='javascript:void(0)'>Télécharger votre facture</a>").appendTo(contentElement)
                        //                $A.on("click", function (e) {
                        //                    jaugeDemarrage.mShow()
                        //                    docCptDetailFinal.mDisplayPdf("a4", function () { jaugeDemarrage.mHide() })
                        //                })
                        //            })
                        //        jaugeDemarrage.mHide()

                        //    }
                        //})
                        //on envoi un mail d'information de reglement CB
                    }
                }).dxCtrlPageSaisieCbSumUp("instance")
            }
            //jaugeDemarrage.mShow()
        })
    }

    function mSendEmailFacture(docCptDetailFacture) {
        var adr = docCptDetailFacture.docCptClient.adresse_email
        if (typeof adr != 'undefined' && adr != null && adr.length > 0) {
            docCptDetailFinal.mGetUrlPdfDocCpt("a4", function (urlPdf) {
                option.bddCtrl.mAjaxCall({
                    command: "sendemailregfacturecb",
                    urlpdf: urlPdf,
                    adresse_email: adr
                })
            })
        }
    }

    function mDisplayResult(htmlText, idTable, id, idSociete, funcContent) {
        dxPageEnteteCb = $("<div style='padding-bottom:10px;'/>").appendTo($DivContainer).dxCtrlEnteteSaisieCb({
            bddCtrl: option.bddCtrl,
            id_table: idTable,
            id: id,
            id_societe: idSociete
        }).dxCtrlEnteteSaisieCb("instance")
        $("<div style= 'padding-top:10px;text-align:center;'>" + htmlText + "</div>").appendTo($DivContainer)
        if (typeof funcContent != 'undefined') {
            funcContent($DivContainer)
        }
    }

    this.element = function () { return container }

    mConstruit();
}